import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import styles from "../../styles/pages/editors.module.scss";
import styles1 from "../../styles/pages/myaccount.module.scss";
import assest from "../../json/assest";
// import Image from 'next/image'
import RequestMessageIcon from "../../ui/Icons/RequestMessageIcon";
import CheckSharpIcon from "../../ui/Icons/CheckSharpIcon";
import UserCreateTabPartner from "../UserCreateTab/UserCreateTabPartner";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const ProfileTabPartner = (props) => {
  return (
    <Box className={styles.ProfilaTabscrollBar}>
      <PerfectScrollbar>
        <Stack
          direction={"row"}
          className={`${styles.editorProfileTab} ${styles.ProfileTabPartner}`}
        >
          <Box
            className={
              props?.classProps === "true"
                ? `${styles1.PfsecLeftPartner} ${styles.PfsecLeft}`
                : `${styles.PfsecLeft}`
            }
          >
            <UserCreateTabPartner
              user_id={props?.user_id}
              forgotText={props?.resettext}
              accountSubmission={props.accountSubmission}
              refetchPartnersList={props?.refetchPartnersList}
              topAcqusitiorRefetch={props?.topAcqusitiorRefetch}
            />
          </Box>

          <Box className={styles.pfSecRight}>
            <Paper
              className={
                props?.classPropsPartner === "true"
                  ? `${styles.partnerPaper} ${styles.partnerPaperforPartner}`
                  : `${styles.partnerPaper}`
              }
            >
              <figure>
                <img src={assest.tipalti} width={78} height={40} alt="icon" />
              </figure>
              <Typography variant="body1">
                Partner's Tipalti account is not set yet.
              </Typography>
              <Typography variant="body1">
                Partner is eligible to receive payments.
              </Typography>
              <Stack
                direction={"row"}
                alignItems={"center"}
                flexWrap={"wrap"}
                className={styles.partnerBtnGrp}
              >
                <Button
                  startIcon={<RequestMessageIcon />}
                  className={styles.reqstbtn}
                >
                  Request Access
                </Button>
                <Button
                  startIcon={<CheckSharpIcon />}
                  className={styles.activebtn}
                >
                  ACTIVE
                </Button>
              </Stack>
            </Paper>
          </Box>
        </Stack>
      </PerfectScrollbar>
    </Box>
  );
};

export default ProfileTabPartner;
